import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { NotificationManager } from 'react-notifications';
import http from '../../services/http';
import Loader from '../loader/loader';

import './createProductForm.less';

class CreateProductForm extends React.Component {
  initialState = {
    values: {},
    errors: {},
    loading: false,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  onFieldChange = fieldName => e => {
    const { value } = e.target;

    this.setState(state => ({
      ...state,
      values: {
        ...state.values,
        [fieldName]: value,
      },
      errors: {
        ...state.errors,
        [fieldName]: null,
      },
    }));
  }

  onSwitchChange = fieldName => e => {
    const event = {
      target: {
        value: !!e.target.checked,
      },
    };
    this.onFieldChange(fieldName)(event);
  }

  onSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { values } = this.state;

    try {
      await http.put('/api/admin/createproduct', values);
      this.setState({ loading: false });
      this.form.reset();
      NotificationManager.success('Dodano nowy produkt!', 'Sukces', 5000);
    } catch (error) {
      console.error(error); // eslint-disable-line no-console

      this.setState({ loading: false });

      const errorMessage = error.errorMessage || 'Nie udało się dodać produktu!';
      NotificationManager.error(errorMessage, 'Błąd', 5000);

      const { errors } = error;

      if (errors) {
        this.setState({ errors });
      }

      return;
    }

    this.setState({ successfullySent: true });

    const { onCreate } = this.props;
    onCreate();
  }

  setFormRef = form => {
    this.form = form;
  }

  renderField = (fieldName, label, props = {}) => {
    const { errors } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const [error] = errors[fieldName] || [];

    return (
      <TextField
        onChange={this.onFieldChange(fieldName)}
        variant="outlined"
        label={label}
        error={!!error}
        helperText={error}
        fullWidth
        {...props}
      />
    );
  }

  render() {
    const { loading } = this.state;

    return (
      <form ref={this.setFormRef} className="login-form-container" onSubmit={this.onSubmit} noValidate>
        {loading && <Loader />}

        <div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {this.renderField('Name', 'Nazwa produktu', { required: true })}
            </Grid>
          </Grid>

          <div className="for-individual-customer-only-switch">
            <FormControlLabel
              control={(
                <Switch
                  onChange={this.onSwitchChange('IsForOnlyIndividualCustomer')}
                />
            )}
              label="Tylko dla klientów indywidualnych"
            />
          </div>

          <div className="send-button-container">
            <Button size="large" variant="contained" color="primary" type="submit">
              Dodaj
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

CreateProductForm.propTypes = {
  onCreate: PropTypes.func.isRequired,
};

export default CreateProductForm;
